import React, { useEffect } from 'react'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Route, Switch, withRouter } from 'react-router-dom'
import 'styles/app/apps/lookup-tables.scss'
import * as ROUTE from 'constants/appRouting'
import { clearLookupTablesStore } from 'reducers/lookupTables/reducer'
import SingleTable from './SingleTable'
import TableList from './TableList'

const LookupTables = props => {
  useEffect(
    () => () => {
      props.clearLookupTablesStore()
    },
    [],
  )

  return (
    <div className="lookup-tables">
      <Switch>
        <Route
          path={ROUTE.LOOKUP_TABLES}
          component={TableList}
          {...props}
          exact
        />
        <Route
          path={ROUTE.LOOKUP_TABLES_SINGLE_TABLE}
          component={SingleTable}
          {...props}
        />
      </Switch>
    </div>
  )
}

export default withRouter(
  connect(null, { clearLookupTablesStore })(injectIntl(LookupTables)),
)
